export default __webpack_public_path__ + "static/media/Chat-Numbers-System-14.35afa80d.svg";